  <template>
  <div class="login">
    <div class="login-content">
      <div class="top">登录</div>
      <div class="close" @click="close"></div>
      <div class="desc">
        报名手机号或邮箱
        <span style="color:#2271ff">*</span>
      </div>
      <input v-model="phone" placeholder="请输入您报名的手机号或邮箱" class="input" />
      <span class="getcode" @click="getCode">获取验证码</span>
      <div class="desc" style="marginTop:50px">
        输入验证码
        <span style="color:#2271ff">*</span>
      </div>
      <input v-model="code" placeholder="请输入验证码" class="input1" />
      <div class="dobut">收不到验证码？</div>
      <div class="commit" @click="onLogin">提交</div>
      <!-- <div style="textAlign:center;color:#2271ff">若您还未报名，请先报名</div> -->
    </div>
  </div>
</template>
<script>
import { callApi } from "../api/callApi";
import {apiMethod} from "../global/config";
import { setToken } from "../utils/auth";
export default {
  data() {
    return {
      phone: "",
      code: "",
      select: ""
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    change() {
      this.$i18n.locale = "en";
      window.localStorage.setItem("qinLang", "en");
      console.log(2);
    },
    changeZh() {
      this.$i18n.locale = "zh";
      window.localStorage.setItem("qinLang", "zh");
    },
    getCode() {
      let data = {
        emailOrPhone: this.phone,
        useWay: 1
      };
      callApi(apiMethod.GET_HALL_CODE, data).then(res => {});
    },
    // 提交
    onLogin() {
      let data = {
        phone: this.phone,
        password: this.code,
        type: 1
      };
      callApi(apiMethod.LOGIN, data).then(res => {
        let token = res.data;
        setToken(token);
        console.log(res);
        if (res.success) {
          callApi(apiMethod.USER_GET_INFO).then(res => {
            console.log(res);
            window.localStorage.setItem('name',res.data.userName)
            if(res.code === 200 && res.success ){
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              this.$router.history.replace('/user')
            }else{
              this.$message.error('验证码错误，请重试');
            }
          });
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.login {
  position: fixed;
  top: 108px;
  width: 100%;
  height: 830px;
  .login-content {
    width: 1280px;
    height: 830px;
    position: absolute;
    z-index: 999;
    left: 50%;
    margin-left: -640px;
    background-color: #fff;
    margin-top: 30px;
    .top {
      text-align: center;
      height: 100px;
      line-height: 100px;
      font-size: 24px;
      font-weight: 700;
    }
    .close {
      width: 56px;
      height: 61px;
      background: url("../assets/imgs/guanbi-2.png") top right no-repeat;
      background-size: 99%;
      transform: translateY(-100px) translateX(1224px);
    }
    .desc {
      width: 900px;
      margin: 20px 190px;
      font-weight: 700;
      color: #2271ff;
    }
    .input {
      width: 670px;
      height: 64px;
      font-size: 20px;
      border: 1px solid rgba(201, 201, 201, 1);
      border-radius: 8px 0 0 8px;
      margin-left: 190px;
      padding: 0 30px;
    }
    .input1 {
      width: 840px;
      height: 64px;
      border: 1px solid rgba(201, 201, 201, 1);
      border-radius: 8px;
      font-size: 20px;
      margin-left: 190px;
      padding: 0 30px;
    }
    .getcode {
      display: inline-block;
      width: 170px;
      height: 67px;
      line-height: 64px;
      text-align: center;
      background: rgba(34, 113, 255, 1);
      border-radius: 0px 8px 8px 0px;
      color: #fff;
      cursor: pointer;
    }
    .dobut {
      width: 900px;
      height: 15px;
      text-align: right;
      margin-left: 190px;
      margin-top: 10px;
      color: #2271ff;
      margin-bottom: 40px;
    }
    .commit {
      width: 300px;
      height: 64px;
      text-align: center;
      line-height: 64px;
      background: rgba(34, 113, 255, 1);
      border-radius: 32px;
      color: #fff;
      margin: 20px auto;
    }
  }
  .shadow {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    opacity: 0.7;
  }
}
</style>


